export default {
	ClickOrDrop: 'Cliquez ici ou déposez votre fichier...',
	Error: 'Erreur de chargement :',
	Close: 'Fermer',
	UnknownError: 'Erreur inconnu. \n Merci de contacter le support',
	ErrorImgName:
		'Le nom de votre image n\'est pas valide. \n Caractéres spéciaux et espace non autorisé',
};
